import { render, staticRenderFns } from "./FirmwideEmissionByScope.vue?vue&type=template&id=13c5b10a"
import script from "./FirmwideEmissionByScope.vue?vue&type=script&lang=js"
export * from "./FirmwideEmissionByScope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports